import React, { useState } from "react";
import styled from "styled-components";
import { OverlayTrigger, Row, Col } from "react-bootstrap";
import {
  ArrowDownIcon,
  ExportIcon,
  ExportIconWhite,
  IconFileDownload,
  Upload,
} from "assets/icons.js";
import { ClearButton, Label, Popover, StyledButton } from "filters/Style";
import DateRangePickerUI from "ui/DateRangePicker";
import ActualService from "services/actual.services";
export const StyledDownloadButton = styled.button`
  width: 170px;
  height: 40px;
  background: #3a3b48 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 26px #00000017;
  border: 1px solid #707070;
  border-radius: 20px;
  text-align: left;
  font-family: Montserrat Alternates-semiBold;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0px;
  color: #ffffff;
  padding: 10px;
  svg {
    margin-left: 55%;
  }
`;

const Input = {
  background: "transparent linear-gradient(270deg,#33c2df 0%,#0081c5 100%)",
  borderRadius: "5px",
  opacity: 1,
  textAlign: "center",
  padding: "3px",
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
  width: "51px",
};

export default function DownloadTransaction({ handleFilterData }) {
  const [invoiceno, setInvoiceno] = useState("");

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [focusedInputDue, setFocusedInputDue] = useState(null);

  const handleResetFilter = () => {
    setInvoiceno("");
    setStartDate("");
    setEndDate("");
  };
  const handleDue = (startDate, endDate) => {};

  const popover = (
    <Popover id="popover-basic">
      <Popover.Body>
        <Row className="m-0" style={{ paddingTop: "5px" }}>
          <Col className="p-0 ">
            <Label>Payment Date</Label>
            <DateRangePickerUI
              handleDate={handleDue}
              startDate={startDate}
              endDate={endDate}
              focusedInput={focusedInputDue}
              setFocusedInput={setFocusedInputDue}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
            />
          </Col>
        </Row>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: "10px",
          }}
        >
          <ClearButton onClick={handleResetFilter}>clear</ClearButton>

          <div className="downTrans">
            {" "}
            <label
              for="image_input"
              style={{ cursor: "pointer", marginRight: "3px" }}
            >
              <div style={Input}>
                <a
                  onClick={async () => {
                    let link = await ActualService.getDownloadTransaction({
                      startDate: startDate,
                      endDate: endDate,
                    });
                    window.open(link, "_blank");
                  }}
                  style={{ textDecoration: "none", color: "#ffffff69" }}
                >
                  {" "}
                  <ExportIconWhite fill={"#fff"} width="20px" height="21px" />
                </a>
              </div>
            </label>
          </div>
        </div>
      </Popover.Body>
    </Popover>
  );
  return (
    <>
      <OverlayTrigger
        trigger="click"
        rootClose
        placement="bottom-end"
        overlay={popover}
      >
        <div className="paymentDownloadWrpper">
          {" "}
          <StyledDownloadButton style={{ marginRight: "15px" }}>
            <span className="paymentDownload">
              <ExportIcon fill={"#fff"} width="20px" height="21px" />{" "}
              <span style={{ marginLeft: "5px" }}>Payments </span>
            </span>
            <ArrowDownIcon />
          </StyledDownloadButton>
        </div>
      </OverlayTrigger>
    </>
  );
}
